'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import H2 from 'UIComponents/elements/headings/H2';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';

const LoadingModal = ({
  network,
  maxSelectableAccounts
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.title.${network}`,
        options: {
          count: maxSelectableAccounts
        }
      })
    })
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    })
  }), /*#__PURE__*/_jsx(UIDialogFooter, {
    children: /*#__PURE__*/_jsx(UILoadingButton, {
      use: "primary",
      loading: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.connectButton"
      })
    })
  })]
});

export default LoadingModal;